import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/pages/Auth";

export const Route = createFileRoute("/auth")({
  head: () => pageHead("Auth \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: Auth,
});
